import {Redirect, Route} from 'react-router-dom';
import {IonApp, IonRouterOutlet, setupIonicReact, IonToast} from '@ionic/react';
import {IonReactRouter} from '@ionic/react-router';
import './assets/components/bootstrap4/bootstrap-grid.scss';


import React, {Suspense, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {ToastContainer} from 'react-toastify';
import get from "lodash/get";
// import TagManager from "react-gtm-module";

import PrivateRouteWithShops from './Components/PrivateRouteWithShops'
// import Preloader from './Components/Preloader'

import NewMessage from "./Pages/Chats/NewMessage";
import Common from './Pages/Settings/Common';
import PersonalSettings from './Pages/Settings/PersonalSettings';
import Team from './Pages/Settings/Team';
import LiveChat from './Pages/Settings/LiveChat';
import Dashboard from './Pages/Main/Dashboard';
import Messages from "./Pages/Chats/Messages";
import Chats from './Pages/Chats/index';
import BotUsers from './Pages/Audience/BotUsers';
import Groups from './Pages/Audience/Groups';
import Leads from './Pages/Audience/Leads';
import BroadcastTasks from './Pages/Broadcasts/Broadcasts';
import NotificationChannels from './Pages/Settings/NotificationChannels';
import {SHOP_SOURCE_CHAT_API} from "./constants";
import AuthTokenAuthorizationWrapper from "./Components/AuthTokenAuthorizationWrapper";
import {
    ActionPerformed,
    PushNotificationSchema,
    PushNotifications,
    Token,
} from '@capacitor/push-notifications';


//
// /* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import Login from "./Pages/Auth/Login";
import ForgotPassword from "./Pages/Auth/ForgotPassword";
import Report from "./Pages/Auth/Report";
import ResetPassword from "./Pages/Auth/ResetPassword";
import {setPushToken} from "./actions/Auth";
import PublicRoute from "./Components/PublicRoute";


// /* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';

/* Theme variables */
import "./assets/ionic/index.scss";
import PushNotificationListener from "./Components/PushNotificationListener";
import AppUrlListener from "./Components/AppUrlListener";

import {Capacitor} from "@capacitor/core";
import {App as CapacitorApp} from '@capacitor/app';
import {SplashScreen} from "@capacitor/splash-screen";

setupIonicReact();

const App: React.FC<{ activeShop: any, isAuthenticated: any, setPushToken: any, shopsAreInitiallyLoaded: any, networkState: boolean }> = ({
                                                                                                                       activeShop,
                                                                                                                       isAuthenticated,
                                                                                                                       setPushToken,
                                                                                                                       shopsAreInitiallyLoaded,
                                                                                                                       networkState,
                                                                                                                   }) => {


    useEffect(() => {
        let listener;
        if (Capacitor.isNativePlatform()) {
            let lastBackDate = Date.now();
            listener = CapacitorApp.addListener("backButton", ({canGoBack}) => {
                if (!canGoBack) {
                    if (Date.now() - lastBackDate < 500) { // logic for double tap: delay of 500ms between two clicks of back button
                        CapacitorApp.exitApp();
                    } else {
                        lastBackDate = Date.now()
                    }
                }
            });
        }
        return () => {
            listener && listener.remove();
        }
    }, []);

    useEffect(() => {
        if (!isAuthenticated || shopsAreInitiallyLoaded) {
            SplashScreen.hide();
        }
    }, [isAuthenticated, shopsAreInitiallyLoaded]);

    const [toastNetworkState, setToastNetworkState] = useState(false);
    useEffect(() => {
        if (navigator.onLine) {
            setToastNetworkState(false);
        } else {
            setToastNetworkState(true);
        }
    }, [networkState]);


    const activeShopId = get(activeShop, 'id', 0);
    return <IonApp>

            <IonReactRouter>
                <AppUrlListener></AppUrlListener>
                <IonRouterOutlet>


                    {/* Небольшой костыль чтобы при logout не кидало на report */}
                    <Route exact path='/auth/report' render={(props) => <Report propsRoute={props}/>}/>
                    <PrivateRouteWithShops
                        path="/:shopId/dashboard/"
                        component={Dashboard}
                    />
                    <PrivateRouteWithShops
                        path="/chats/"
                        component={Chats}
                    />
                    <PrivateRouteWithShops
                        path="/newMessage/"
                        component={NewMessage}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/chat/:activeChatId/"
                        component={Messages}
                    />

                    <PrivateRouteWithShops
                        path="/:shopId/audience/bot_users/"
                        component={BotUsers}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/broadcasts/tasks/"
                        component={BroadcastTasks}
                    />
                    {/* Settings */}
                    <PrivateRouteWithShops
                        path="/:shopId/settings/common/"
                        component={Common}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/personal_settings/"
                        component={PersonalSettings}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/notifications/"
                        component={NotificationChannels}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/live_chat/"
                        component={LiveChat}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/team/"
                        component={Team}
                    />

                    <ToastContainer/>

                </IonRouterOutlet>
                {/*<PushNotificationListener/>*/}
            </IonReactRouter>
        <IonToast
            isOpen={toastNetworkState}
            message="No internet"
            duration={2000}
            position="top"
            mode="md"
        />
    </IonApp>
}


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    isAuthenticated: state.Auth.isAuthenticated,
    shopsAreInitiallyLoaded: state.Shops.shopsAreInitiallyLoaded,
    networkState: state.Auth.networkState,
});


const mapDispatchToProps = dispatch => ({
    setPushToken: (message) => dispatch(setPushToken(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);


